(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));

      this.formatCouponCode();
    }

    formatCouponCode() {
      const messages = this.querySelectorAll('.announcement-bar__message');

      messages.forEach((message) => {
        const walker = document.createTreeWalker(message, NodeFilter.SHOW_TEXT);

        const textNodes = [];

        while (walker.nextNode()) {
          textNodes.push(walker.currentNode);
        }

        textNodes.forEach((textNode) => {
          const text = textNode.nodeValue;

          const match = text.match(/Code:\s*([A-Za-z0-9_-]+)/i);

          if (!match) {
            return;
          }

          const code = match[1];

          const startIndex = match.index + match[0].lastIndexOf(code);

          const before = text.substring(0, startIndex);

          const after = text.substring(startIndex + code.length);

          const fragment = document.createDocumentFragment();

          if (before) {
            fragment.appendChild(document.createTextNode(before));
          }

          const codeSpan = document.createElement('span');

          codeSpan.className = 'announcement-bar__coupon-code';

          codeSpan.textContent = code;

          fragment.appendChild(codeSpan);

          if (after) {
            fragment.appendChild(document.createTextNode(after));
          }

          textNode.parentNode.replaceChild(fragment, textNode);
        });
      });
    }

    handleClick(e) {
      /* ---------------------------------
       CLOSE BUTTON
    --------------------------------- */

      const closeButton = e.target.closest('.announcement-bar__close');

      if (closeButton) {
        e.preventDefault();
        e.stopPropagation();

        const { closeAnnouncement } = closeButton.dataset;

        if (closeAnnouncement === 'row') {
          closeButton.closest('.announcement-bar__row').remove();
        } else {
          this.remove();
        }

        return;
      }

      /* ---------------------------------
       ANNOUNCEMENT BAR
    --------------------------------- */

      const announcementRow = e.target.closest('.announcement-bar__row');

      if (!announcementRow) {
        return;
      }

      const message = announcementRow.querySelector('.announcement-bar__message');

      if (!message) {
        return;
      }

      /* ---------------------------------
       FIND COUPON CODE
    --------------------------------- */

      const text = message.textContent.trim();

      const match = text.match(/Code:\s*([A-Za-z0-9_-]+)/i);

      if (!match) {
        return;
      }

      const code = match[1];

      /* ---------------------------------
       COPY FUNCTION
    --------------------------------- */

      const showCopied = () => {
        const originalHTML = message.innerHTML;

        message.innerHTML = '✓ Code copied!';

        setTimeout(() => {
          message.innerHTML = originalHTML;
        }, 1500);
      };

      /* ---------------------------------
       COPY TO CLIPBOARD
    --------------------------------- */

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(code)
          .then(() => {
            showCopied();
          })
          .catch(() => {
            this.fallbackCopy(code, showCopied);
          });
      } else {
        this.fallbackCopy(code, showCopied);
      }
    }

    fallbackCopy(text, callback) {
      const textarea = document.createElement('textarea');

      textarea.value = text;

      textarea.style.position = 'fixed';

      textarea.style.left = '-9999px';

      textarea.style.top = '0';

      textarea.style.opacity = '0';

      document.body.appendChild(textarea);

      textarea.focus();
      textarea.select();

      try {
        const successful = document.execCommand('copy');

        if (successful) {
          callback();
        }
      } catch (err) {
        console.error('Unable to copy coupon code:', err);
      }

      textarea.remove();
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterCollapsible extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
      this.openDefault = this.dataset.openDefault === 'true';

      this.details.addEventListener(
        'keyup',
        (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      document.addEventListener('matchTablet', this.close.bind(this));
      document.addEventListener('unmatchTablet', this.open.bind(this));

      if (FoxThemeSettings.isTablet) {
        if (!this.openDefault) this.close();
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.close();
        } else {
          this.open();
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open();
      });
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open')
        ? this.close()
        : this.open();
    }

    open() {
      this.details.setAttribute('open', true);
    }

    close() {
      !this.summaryIsEmpty && this.details.removeAttribute('open');
    }
  }

  customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super();
      document.body.classList.add('mobile-sticky-bar-enabled');
    }

    connectedCallback() {
      document.documentElement.style.setProperty('--f-mobile-navbar-height', this.offsetHeight + 'px');
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar);

  } catch(e) { console.error(e); }
})();
})();
